export default {
  title: 'Jobs',
  tab: 'JOBS'
}
